const HELP_BASE = "/help/how-to-start/";

const resolveSrc = (src) => {
  if (/^https?:\/\//i.test(src) || src.startsWith("/")) return src;
  return `${HELP_BASE}${src.replace(/^\.\//, "")}`;
};

const splitCells = (line) =>
  line
    .trim()
    .replace(/^\|/, "")
    .replace(/\|$/, "")
    .split("|")
    .map((cell) => cell.trim());

const isSeparator = (line) => /^\|?\s*:?-{3,}:?\s*(\|\s*:?-{3,}:?\s*)+\|?$/.test(line.trim());

const parseTable = (rows) => {
  const body = rows.filter((row) => !isSeparator(row)).map(splitCells);
  return { type: "table", head: body[0] || [], rows: body.slice(1) };
};

export const parseInline = (text) => {
  const tokens = [];
  const re = /!\[([^\]]*)\]\(([^)]+)\)|\*\*([^*]+)\*\*|`([^`]+)`|\[([^\]]+)\]\(([^)]+)\)/g;
  let last = 0;
  let match;
  while ((match = re.exec(text))) {
    if (match.index > last) tokens.push({ type: "text", value: text.slice(last, match.index) });
    if (match[1] != null) {
      tokens.push({ type: "image", alt: match[1], src: resolveSrc(match[2]) });
    } else if (match[3] != null) {
      tokens.push({ type: "strong", value: match[3] });
    } else if (match[4] != null) {
      tokens.push({ type: "code", value: match[4] });
    } else {
      const href = match[6];
      const docLink = !/^https?:\/\//i.test(href);
      tokens.push(docLink ? { type: "text", value: match[5] } : { type: "link", href, value: match[5] });
    }
    last = match.index + match[0].length;
  }
  if (last < text.length) tokens.push({ type: "text", value: text.slice(last) });
  return tokens;
};

export const parseMarkdown = (md) => {
  const lines = md.replace(/\r\n/g, "\n").split("\n");
  const blocks = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    if (!line.trim()) {
      i += 1;
      continue;
    }

    if (/^---+$/.test(line.trim())) {
      blocks.push({ type: "hr" });
      i += 1;
      continue;
    }

    const heading = line.match(/^(#{1,3})\s+(.+)$/);
    if (heading) {
      blocks.push({ type: "heading", level: heading[1].length, text: heading[2] });
      i += 1;
      continue;
    }

    if (line.trim().startsWith("|")) {
      const rows = [];
      while (i < lines.length && lines[i].trim().startsWith("|")) {
        rows.push(lines[i]);
        i += 1;
      }
      blocks.push(parseTable(rows));
      continue;
    }

    const image = line.match(/^!\[([^\]]*)\]\(([^)]+)\)$/);
    if (image) {
      blocks.push({ type: "image", alt: image[1], src: resolveSrc(image[2]) });
      i += 1;
      continue;
    }

    const para = [];
    while (
      i < lines.length &&
      lines[i].trim() &&
      !lines[i].trim().startsWith("|") &&
      !/^---+$/.test(lines[i].trim()) &&
      !/^#{1,3}\s/.test(lines[i]) &&
      !/^!\[[^\]]*\]\([^)]+\)$/.test(lines[i])
    ) {
      para.push(lines[i].trim());
      i += 1;
    }
    blocks.push({ type: "paragraph", text: para.join(" ") });
  }

  return blocks;
};
